<template>
    <basic-container>
        <avue-crud v-if="reWrite"
                   :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.questionnairetopic_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/questionnaire/topic/questionnaireretopic";
    import {mapGetters} from "vuex";
    import {getProjectList} from "@/api/crmedical/project/project";
    import {getProjectDict} from "@/api/crmedical/project-dictionary/project-dictionary";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                firstDisplayFlag:false,
                reWrite: false,
                tempProjectId: '',
                projectList:[],
              option: {
                height: 'auto',
                calcHeight: 50,
                tip: false,
                border: true,
                indexLabel:'序号',
                index: true,
                viewBtn: true,
                selection: true,
                columnBtn: false,
                refreshBtn: false,
                searchMenuSpan: 6,
                column: [
                  {
                    label: "主键",
                    prop: "id",
                    editDisplay: false,
                    addDisplay: false,
                    viewDisplay: false,
                    hide: true,
                  },
                  {
                    label: "项目名称",
                    prop: "projectId",
                    type: 'tree',
                    cascaderItem: ['serviceType'],
                    searchClearable:false,
                    editDisabled:true,
                    search: true,
                    dicUrl: '/api/v4ward/project/getProjectList',
                    props: { label: 'name', value: 'id' },
                    rules: [{
                      required: true,
                      message: "请选择项目名称",
                      trigger: "change"
                    }]
                  },
                  {
                    label: "考核对象",
                    prop: "serviceType",
                    type: "select",
                    search: true,
                    dataType: 'string',
                    dicUrl: "/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}",
                    props: {
                      label: "dictValue",
                      value: "dictKey",
                    },
                    rules: [{
                      required: true,
                      message: "请选择考核对象",
                      trigger: "blur"
                    }]
                  },
                  {
                    label: "题目名称",
                    prop: "name",
                    search: true,
                    maxlength: 30,
                    showWordLimit: true,
                    overHidden: true,
                    rules: [{
                      required: true,
                      message: "请输入题目名称",
                      trigger: "blur"
                    }]
                  },
                  {
                    label: "不合格文字提示",
                    prop: "reasonPlaceholder",
                    search: false,
                    labelWidth: 130,
                    maxlength: 30,
                    showWordLimit: true,
                    overHidden: true,
                    rules: [{
                      required: false,
                      message: "请输入不合格提示语",
                      trigger: "blur"
                    }]
                  },
                  {
                    label: "题目内容",
                    prop: "topic",
                    type: 'textarea',
                    span: 24,
                    row: 4,
                    maxlength: 200,
                    showWordLimit: true,
                    overHidden: true,
                    rules: [{
                      required: true,
                      message: "题目内容",
                      trigger: "blur"
                    }]
                  },
                  {
                    label: "分值",
                    prop: "score",
                    maxlength: 6,
                    showWordLimit: true,
                    rules: [
                      { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },
                      {
                        required: true,
                        message: "请输入分值",
                        trigger: "blur"
                      }]
                  },
                  {
                    label: "排序",
                    prop: "sort",
                    maxlength: 6,
                    showWordLimit: true,
                    rules: [
                      { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },
                      {
                        required: true,
                        message: "请输入排序号",
                        trigger: "blur"
                      }]
                  },
                ]
              },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.questionnairetopic_add, false),
                    viewBtn: this.vaildData(this.permission.questionnairetopic_view, false),
                    delBtn: this.vaildData(this.permission.questionnairetopic_delete, false),
                    editBtn: this.vaildData(this.permission.questionnairetopic_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      created() {
        //加载列表
        getProjectList({}).then((res) => {
          this.projectList = res.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.tempProjectId = this.projectList[0].id;
            getProjectDict({projectId:this.query.projectId,code:'project_examine_service_type'}).then(({ data }) => {
              this.findObject(
                this.option.column,
                'serviceType'
              ).dicData = data;
            });
          }
          this.$nextTick(() => {
            this.reWrite = true;
          });
          //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
          this.firstDisplayFlag = true;
        });
      },
      watch: {
        'form.projectId'() {
          this.query.serviceType = '';
        },
      },
        methods: {
          getProjectNameById(projectId) {
            let projectName = '';
            this.projectList.forEach(function (value, index, array) {
              if (value.id === projectId) {
                projectName = value.name;
                return;
              }
            });
            return projectName;
          },
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                      this.form.serviceType = this.form.serviceType.toString();
                    });
                } else {
                  setTimeout(()=>{
                      this.form.projectId = this.query.projectId;
                  },0)
                }
                done();
            },
            searchReset() {
                this.query.name = '';
                this.query.serviceType = '';
                this.firstDisplayFlag = true;
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
          onLoad(page) {
            page = page || this.page;
            this.loading = true;
            //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
            if (!this.query.projectId ) {
              this.query.projectId = this.tempProjectId;
            }
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
                if (this.firstDisplayFlag) {
                  let ent = document.querySelector('input[placeholder="项目名称"]');
                  ent.value = this.getProjectNameById(this.query.projectId);
                  this.tempProjectId = this.query.projectId
                  //关闭默然显示，重刷页面时才开启默认显示
                  this.firstDisplayFlag = false;
                }
              });
          }
        }
    };
</script>

<style>
</style>
